import { render, staticRenderFns } from "./BulkActionModal.vue?vue&type=template&id=62613e8c"
import script from "./BulkActionModal.vue?vue&type=script&lang=js"
export * from "./BulkActionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports